import { getBaseUrl } from "../../library/helpers/utility";
import http from "../api";
import axios from "axios";

class ActivityDataService {
    getAll() {
        return http({
            'url':'/activity',
            'method':'GET',
        });
    }

    getActivityById(id) {
        return http({
            'url':'/activity/'+id,
            'method':'GET'
        });
    }

    getAlertsFromActivityById(id) {
        return http({
            'url':'/activity/alerts/'+id,
            'method':'GET'
        });
    }

    getStagesFromActivityById(id) {
        return http({
            'url':'/activity/stages/'+id,
            'method':'GET'
        });
    }

    getByParameter(what, parameter) {
        return http({
            'url':'/activity/find/'+what+'/'+parameter,
            'method':'GET'
        });
    }

    getActivityByCliente(id) {
        return http({
            'url':'/activity/client/'+id,
            'method':'GET'
        });
    }

    createActivityData(data) {
        return http({
            'url':'/activity',
            'method':'POST',
            'data': data
        });
    }

    registerOpenActivitie(id) {
        return http({
            'method':'POST',
            'url':'/activity/registerOpenActivitie/'+id,
        });
    }

    registerOpenedActivitieTime(id) {
        return http({
            'method':'POST',
            'url':'/activity/registerOpenedActivitieTime/'+id,
        });
    }

    registerCloseActivitie(id) {
        return http({
            'method':'POST',
            'url':'/activity/registerCloseActivitie/'+id,
        });
    }

    sendActivityAttachments(id, data) {
        let headers = {
            'Content-Type':'multipart/form-data; boundary=----WebKitFormBoundaryYfmIyu4VricsS1by'
        }

        const tenantId = localStorage.getItem('tenantId');
        if (tenantId) {
            headers['x-tenant-id'] = tenantId;
        }

        return axios({
            baseURL: getBaseUrl(),
            method:'PUT',
            url:'/files/activity/'+id,
            headers: headers,
            withCredentials:true,
            'data': data
        });
    }

    updateActivityData(id, data, currentBoard) {
        return http({
            'url':'/activity/'+id+'/'+currentBoard,
            'method':'PUT',
            'data': data
        });
    }
    
    createContasByActivity(idActivity, data) {
        return http({
            'url':'/activity/gerar_contas/'+idActivity,
            'method':'POST',
            'data': data
        });
    }


    removeAlertActivityData(id, which) {
        return http({
            'url':'/activity/removeAlert/'+id+'/'+which,
            'method':'PUT',
            'data': {}
        });
    }

    defineResponsibleActivityData(data) {
        return http({
            'url':'/activity/defineResponsible',
            'method':'PUT',
            'data': data
        });
    }

    definePriorityActivityData(data) {
        return http({
            'url':'/activity/definePriority',
            'method':'PUT',
            'data': data
        });
    }

    removeActivity(id, data) {
        return http({
            'url':'/activity/'+id,
            'method':'DELETE',
            'data': data
        });
    }
}

export default new ActivityDataService();